import * as Sentry from "@sentry/react";

type CaptureOptions = {
  tags: Record<string, string>;
  fingerprint: string[];
  context: Record<string, Record<string, unknown>>;
};

export function capture(error: Error, { tags, fingerprint, context }: CaptureOptions): string {
  return Sentry.captureException(error, { tags, fingerprint, contexts: context });
}
